"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_CITIES = exports.RESET_STATES = exports.GET_CITIES = exports.GET_COUNTRIES = exports.GET_STATES = exports.INITIAL_SCREEN_STATE = void 0;
const INITIAL_SCREEN_STATE = {
    loading: false,
    error: null,
    cities: [],
    states: [],
    countries: []
};
exports.INITIAL_SCREEN_STATE = INITIAL_SCREEN_STATE;
const GET_COUNTRIES = 'address/GET_COUNTRIES';
exports.GET_COUNTRIES = GET_COUNTRIES;
const GET_STATES = 'address/GET_STATES';
exports.GET_STATES = GET_STATES;
const GET_CITIES = 'address/GET_CITIES';
exports.GET_CITIES = GET_CITIES;
const RESET_STATES = 'address/RESET_STATES';
exports.RESET_STATES = RESET_STATES;
const RESET_CITIES = 'address/RESET_CITIES';
exports.RESET_CITIES = RESET_CITIES;
//# sourceMappingURL=index.js.map